<template>
	<div
		v-if="data.cheat_sheet.length"
		class="cheatsheet"
	>
		<h4>The Cheat Sheet</h4>

		<ol>
			<li
				v-for="(c, i) in data.cheat_sheet"
				:key="i"
			>
				{{ c }}
			</li>
		</ol>

		<a
			href="https://realschools.com.au/"
			title="Back to realschools.com.au main site"
			class="logo"
		>
			<img
				src="@/images/logo-stacked-reverse.svg?inline"
				alt="Real Schools"
			/>
		</a>
	</div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue';
import type { Resource } from '@/interfaces/resourceInterface';

export default defineComponent({
	props: {
		data: {
			type: Object as PropType<Resource>,
			required: true,
		},
	},
});
</script>

<style scoped lang="scss">
@use '@/styles/utils';

.cheatsheet {
	-webkit-column-break-inside: avoid;
	break-inside: avoid;
	page-break-inside: avoid;
	background-color: rgb(var(--rs-color-brand-navy));
	padding: 30px var(--rs-layout-content-padding) 20px var(--rs-layout-content-padding);
	color: rgb(var(--rs-color-brand-white));

	h4 {
		display: block;
		margin: 0 0 23px 0;
		border-bottom: 1px solid rgb(var(--rs-color-brand-sky));
		padding-bottom: 9px;
		color: rgb(var(--rs-color-brand-sky));
		font-size: 2.1rem;
		font-family: var(--rs-typography-font-body);
		letter-spacing: 0.07em;
		text-align: center;
		text-transform: uppercase;
	}

	ol {
		margin-top: 0;
		margin-bottom: 0;
		font-size: 1.7rem;

		li {
			margin-bottom: 0.7em;

			&::marker {
				color: rgb(var(--rs-color-brand-mustard));
			}
		}
	}

	.logo {
		display: none;
		margin: 4em 0 1em 1em;
		max-width: 120px;

		img {
			width: 100%;
		}
	}
}

@media only print {
	.cheatsheet {
		.logo {
			display: block;
		}
	}
}
</style>
